import React, { useContext } from 'react';
import { applicationContext } from 'helpers/services';
import { NavBar, Footer } from 'components';
import { makeStyles } from '@material-ui/core';


interface IProps {
    children: React.ReactNode
}

const useStyles = makeStyles(theme => ({
    footer: {
        marginTop: theme.spacing(6)
    }
}))

let Layout = ({ children }: IProps) => {
    let classes = useStyles();

    let appService = useContext(applicationContext);

    return (
        <>
            {appService.isLoading === false &&
                <>
                    <NavBar />
                    {children}
                    <footer className={classes.footer}>
                        <Footer />
                    </footer>
                </>
            }
        </>
    )
}

export default Layout;